import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ScreenSizeService {
  screenWidth = signal(this.getScreenWidth());

  constructor() {
    window.addEventListener("resize", () => {
      this.screenWidth.set(this.getScreenWidth());
    });
  }

  // Returns the lesser of window.innerWidth and window.screen.width.
  // window.innerWidth is better for desktop, window.screen.width is more accurate on mobile.
  private getScreenWidth(): number {
    return Math.min(window.innerWidth, window.screen.width);
  }
}
